import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export const FILIAL_EXCEL_HEADERS = [
  'RazaoSocial',
  'Fantasia',
  'CnpjCpf',
  'Email',
  'Telefone',
  'Logradouro',
  'Numero',
  'Complemento',
  'Bairro',
  'Cidade',
  'UF',
  'Cep',
  'CodigoIbge',
  'InscricaoMunicipal',
  'CnaePrincipal',
  'DownloadDestinadas',
];

const EXEMPLO = {
  RazaoSocial: 'Filial Exemplo Ltda',
  Fantasia: 'Filial Centro',
  CnpjCpf: '00000000000272',
  Email: 'filial@exemplo.com',
  Telefone: '11988887777',
  Logradouro: 'Av Exemplo',
  Numero: '200',
  Complemento: '',
  Bairro: 'Centro',
  Cidade: 'Sao Paulo',
  UF: 'SP',
  Cep: '01001000',
  CodigoIbge: '3550308',
  InscricaoMunicipal: '',
  CnaePrincipal: '',
  DownloadDestinadas: 'Sim',
};

function toBool(v) {
  if (typeof v === 'boolean') return v;
  const s = String(v ?? '').trim().toLowerCase();
  return s === 'sim' || s === 'true' || s === '1' || s === 'yes';
}

export function downloadModeloFiliaisExcel() {
  const ws = XLSX.utils.json_to_sheet([EXEMPLO], { header: FILIAL_EXCEL_HEADERS });
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Filiais');
  const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  saveAs(new Blob([buf], { type: 'application/octet-stream' }), 'MODELO_IMPORTACAO_FILIAIS.xlsx');
}

export function parseFiliaisExcelFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const wb = XLSX.read(data, { type: 'array' });
        const sheet = wb.Sheets[wb.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(sheet, { defval: '' });
        const linhas = rows.map((row) => ({
          razaosocial: String(row.RazaoSocial ?? row.razaosocial ?? '').trim(),
          fantasia: String(row.Fantasia ?? row.fantasia ?? '').trim(),
          pessoa: 'Juridica',
          cnpjcpf: String(row.CnpjCpf ?? row.cnpjcpf ?? row.CNPJ ?? '').replace(/\D/g, ''),
          email: String(row.Email ?? row.email ?? '').trim(),
          telefone: String(row.Telefone ?? row.telefone ?? '').trim(),
          logradouro: String(row.Logradouro ?? row.logradouro ?? '').trim(),
          numero: String(row.Numero ?? row.numero ?? '').trim(),
          complemento: String(row.Complemento ?? row.complemento ?? '').trim(),
          bairro: String(row.Bairro ?? row.bairro ?? '').trim(),
          cidade: String(row.Cidade ?? row.cidade ?? '').trim(),
          uf: String(row.UF ?? row.uf ?? '').trim().toUpperCase(),
          cep: String(row.Cep ?? row.cep ?? '').replace(/\D/g, ''),
          codigoIbge: String(row.CodigoIbge ?? row.codigoIbge ?? '').trim(),
          inscricaoMunicipal: String(row.InscricaoMunicipal ?? row.inscricaoMunicipal ?? '').trim(),
          cnaePrincipal: String(row.CnaePrincipal ?? row.cnaePrincipal ?? '').trim(),
          downloadDestinadas: toBool(row.DownloadDestinadas ?? row.downloadDestinadas ?? 'Sim'),
        }));
        resolve(linhas);
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = () => reject(new Error('Falha ao ler o arquivo'));
    reader.readAsArrayBuffer(file);
  });
}
